import axios from "axios";

// Configure axios to send cookies with all requests
// This is necessary for session-based authentication to work properly
axios.defaults.withCredentials = true;

export default axios;
